// removed by extract-text-webpack-plugin
module.exports = {"awaiting-processing-container":"awaiting-processing__awaiting-processing-container___RObRy","pending-item":"awaiting-processing__pending-item___DtFPI","active-pending-item":"awaiting-processing__active-pending-item___1rnxZ","stuck":"awaiting-processing__stuck___2yxo4"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/upload-documents/awaiting-processing.scss
// module id = 1368
// module chunks = 0